import { render, staticRenderFns } from "./RewardCatalog.vue?vue&type=template&id=74ee6242&scoped=true"
import script from "./RewardCatalog.vue?vue&type=script&lang=js"
export * from "./RewardCatalog.vue?vue&type=script&lang=js"
import style0 from "./RewardCatalog.vue?vue&type=style&index=0&id=74ee6242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ee6242",
  null
  
)

export default component.exports